<template lang="html">
  <v-container>
    <StandardDialog v-if="show_dialog" @click-outside="show_dialog=false">
      <template #content>
        <StandardTextCard
          height="74vh"
          :name="'PRO.user: ' + dialog.first_name + ' ' + dialog.last_name"
          :clickable="false"
        >
          <template #info>
            <h3>Information</h3>
            <v-form>
              <div class="select-container">
                <v-text-field disabled v-model="dialog.billing_address.country" label="BILLING.address country" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.billing_address.zip_code" label="BILLING.address zip code" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.billing_address.state" label="BILLING.address state" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.billing_address.city" label="BILLING.address city" type="text"></v-text-field>
              </div>
              <div class="select-container">
                <v-text-field disabled v-model="dialog.billing_address.street" label="BILLING.address street" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.billing_address.building_number" label="BILLING.address building number" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.billing_address.custom_information" label="BILLING.address custom information" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.vat_number" label="VAT.number" type="text"></v-text-field>
              </div>
              <div class="clear"></div>
              <!-- <v-text-field disabled v-model="dialog.business_name" label="COMPANY.name" type="text"></v-text-field>
              <v-text-field disabled v-model="dialog.business_description" label="COMPANY.description" type="text"></v-text-field>
              <v-text-field disabled v-model="dialog.business_emails" label="COMPANY.email domains (comma separated)" placeholder="@takting.com, @example.com" type="text"></v-text-field> -->
            </v-form>
            <h3>Pro User Roles</h3>
            <div style="width: 100%">
              <v-card
              class="float-left mr-2"
              dark
              width="20%"
              v-for="pro_user_role in dialog.pro_user_roles"
              :key="`pro_user_role${pro_user_role.id}`"
              >
                <v-card-title class="text-h5">
                  {{pro_user_role.name}}
                </v-card-title>

                <v-card-subtitle>{{pro_user_role.description}}</v-card-subtitle>

                <v-card-actions>
                  <v-btn text color="error" @click="removeProUserRoles({user_id: dialog.id, roles: [{id: pro_user_role.id}]})">
                    Remove
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </template>
          <template #actions>
            <v-btn color="red" text disabled @click="removeProAccount({id: dialog.id})">Remove PRO.user</v-btn>
            <v-btn color="grey" text @click="show_dialog=false">Cancel</v-btn>
          </template>
        </StandardTextCard>
      </template>
    </StandardDialog>
    <v-row>
      <v-col xs12 md8 v-if="getProUser.length === 0">
        <v-card>
          <h1>No user upgrades here...</h1>
        </v-card>
      </v-col>
      <v-col xs12 md8 v-if="getProUser.length > 0">
        <v-data-table
          :headers="headers"
          :items="getProUser"
          :sort-by="[]"
          :sort-desc="[false, true]"
          multi-sort
          single-select
          class="elevation-1"
        >
          <template v-slot:item.copy="{ item }">
            <v-tooltip
              :open-on-hover="false"
              bottom
            >
              <template #activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  :disabled="!hasPermission('User READ ALL')"
                  @click="on.click"
                  @blur="on.blur"
                  @click.native="copyEmail(item.email)"
                >
                  content_copy
                </v-icon>
              </template>
              <span>Copied Email to clipboard</span>
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              medium
              class="mr-2"
              @click="showDialog(item)"
            >
              info
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store/index';
export default {
  name: 'ProUser',
  components: { StandardDialog, StandardTextCard },
  beforeRouteEnter (to, from, next) {
    store.dispatch('User/requestProUser').then(res => next(res));
  },
  data: function () {
    return {
      show_dialog: false,
      dialog: {},
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Email', value: 'email' },
        { text: 'Copy Email to Clipboard', value: 'copy' },
        { text: 'First Name', value: 'first_name' },
        { text: 'Last Name', value: 'last_name' },
        { text: 'Pro Account', value: 'business' },
        { text: 'Actions', value: 'actions', sortable: false },
      ]
    }
  },
  computed: {
    ...mapGetters('User', [
      'getProUser'
    ]),
    ...mapGetters('Auth', [
      'hasPermission'
    ])
  },
  methods: {
    ...mapActions('User', [
      'requestUserUpgradesForManagement',
      'deleteUserUpgrade',
      'removeProUserRoles'
    ]),
    copyEmail(email){
      navigator.clipboard.writeText(email);
    },
    showDialog(item){
      this.dialog = item;
      this.show_dialog = true;
    },
    deleteUserUpgradeDialog(payload){
      this.deleteUserUpgrade(payload);
      let self = this;
      setTimeout(function () {
        self.show_dialog = false;
      }, 1500);
    },
    getRequestedRole(type){
      switch (type) {
        case 'FullUser':
          return 'FULL.user'
        case 'Business':
          return 'PRO.user COMPANY'
        case 'Single':
          return 'PRO.user SINGLE'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="css" scoped>
.select-container {
  width: 45%;
  padding: 10px;
  margin: 10px;
  position: relative;
  float: left;
}
</style>
